export default __webpack_public_path__ + "static/Christmas-Lights-f8486b38d0a484c72b95590a95c99134.gif";